// ======================================================================
// File: src/modules/ipe/enquiry/components/EnquiriesFilterBar.js
// ======================================================================

import React, { useState, useEffect } from "react";

export default function EnquiriesFilterBar({ filters, onApply }) {
  const [local, setLocal] = useState({
    q: "",
    status: "",
    from_date: "",
    to_date: "",
  });

  // Sync external reset
  useEffect(() => {
    setLocal({
      q: filters.q || "",
      status: filters.status || "",
      from_date: filters.from_date || "",
      to_date: filters.to_date || "",
    });
  }, [filters]);

  const update = (k, v) => setLocal({ ...local, [k]: v });

  return (
    <div className="card mb-3">
      <div className="card-body">
        <div className="d-flex flex-wrap align-items-end gap-2">

          {/* Search */}
          <div style={{ minWidth: 220 }}>
            <input
              className="form-control"
              placeholder="Search Enquiry No / Customer"
              value={local.q}
              onChange={(e) => update("q", e.target.value)}
            />
          </div>

          {/* Status */}
          <div style={{ minWidth: 180 }}>
            <select
              className="form-select"
              value={local.status}
              onChange={(e) => update("status", e.target.value)}
            >
              <option value="">All Status</option>
              <option value="DRAFT">Draft</option>
              <option value="NEW">New</option>
              <option value="ENGINEERING_STUDY">Engineering Study</option>
              <option value="BOM_PREPARATION">BOM Preparation</option>
              <option value="COST_ESTIMATION">Cost Estimation</option>
              <option value="QUOTATION_PREPARATION">Quotation Preparation</option>
              <option value="QUOTATION_SENT">Quotation Sent</option>
              <option value="CLOSED">Closed</option>
            </select>
          </div>

          {/* From Date */}
          <div>
            <input
              type="date"
              className="form-control"
              value={local.from_date}
              onChange={(e) => update("from_date", e.target.value)}
            />
          </div>

          {/* To Date */}
          <div>
            <input
              type="date"
              className="form-control"
              value={local.to_date}
              onChange={(e) => update("to_date", e.target.value)}
            />
          </div>

          {/* Actions */}
          <div className="d-flex gap-2">
            <button
              className="btn btn-primary"
              onClick={() => onApply(local)}
            >
              Apply
            </button>

            <button
              className="btn btn-outline-secondary"
              onClick={() => onApply({})}
            >
              Reset
            </button>
          </div>

        </div>
      </div>
    </div>
  );
}